export default __webpack_public_path__ + "static/media/add-button-colored.875b9c42.svg";